import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './personalDetailPage.css';
import Header from "../components/common/header";
import Footer from "../components/common/footer";
import { useExchangeUser } from '../../contexts/userExchangeProgramContext';

interface City {
    city: string;
    state_name: string;
    pincode:string;

}

const PersonalInfoFormPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [name, setName] = useState('');
    const [mobileNo, setMobileNo] = useState('');
    const [email, setEmail] = useState('');
    const [pincode, setPincode] = useState('');
    const [houseNumber, setHouseNumber] = useState('');
    const [streetAddress, setStreetAddress] = useState('');
    const [cityState, setCityState] = useState<City | null>(null);
    const [locality, setLocality] = useState('');  // Selected locality
    const [localities, setLocalities] = useState<string[]>([]);
    const [city, setCity] = useState('');
    const [state, setState] = useState('');

    const [error, setError] = useState<{ [key: string]: string | null }>({
        name: null,
        mobileNo: null,
        email: null,
        pincode: null,
        houseNumber: null,
        streetAddress: null,
        locality: null,
        city: null,
        state: null,
    });
    const [loading, setLoading] = useState(false);

    const { servicable_pincode,order_id ,setUserId,user_id,setCustInfo,personalDetailsPageForm,profileDetailsFormValidation,allFieldCommanError,allCommanErrors,fetchCsrfToken} = useExchangeUser();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const version = process.env.REACT_APP_VERSION;
  const prog_id = location.state?.prog_id
  const storeData = location.state?.storeData
  const personalNameRef = useRef<HTMLInputElement | null>(null);

    const validateFields = () => {
        let isValid = true;
        const newErrors: { [key: string]: string | null } = {
            name: null,
            mobileNo: null,
            email: null,
            pincode: null,
            houseNumber: null,
            streetAddress: null,
            locality: null,
            city: null,
            state: null,
        };

        // Name validation
        if (!name) {
            newErrors.name = 'Please enter the name';
            isValid = false;
        } else if (/[^a-zA-Z\s]/.test(name)) {
            newErrors.name = 'Name should not contain numbers or special characters';
            isValid = false;
        }

        // Mobile number validation
        if (!mobileNo) {
          newErrors.mobileNo = 'Please enter the mobile number';
          isValid = false;
      } 
      else if (!/^\d{10}$/.test(mobileNo)) {  
          newErrors.mobileNo = 'Please enter a valid 10-digit mobile number';
          isValid = false;
      } 
      else if (mobileNo === '0000000000') {  
          newErrors.mobileNo = 'Invalid mobile number';
          isValid = false;
      } 
      else if (mobileNo.startsWith('0')) {  
          newErrors.mobileNo = 'Please enter a correct mobile number';
          isValid = false;
      }  

        // Email validation
      if (!email) {
        newErrors.email = 'Please enter the email';
        isValid = false;
      } 
      else if (!/^[a-zA-Z0-9@._-]+$/.test(email)) {
            
        newErrors.email = 'Only alphabets, numbers, and special characters (@, ., -, _) are allowed'
        isValid = false;
            
      } else if (!/^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(email)) {
        newErrors.email = 'Please enter a valid email id'
        isValid = false;
      } else if (/^[0-9]+@/.test(email)) {
        // Check if the part before @ is only numeric
        newErrors.email = 'The part before @ cannot be only numeric'
        isValid = false;
      } else {
        setError((prev) => ({ ...prev, email: null }));
      }

      if (!houseNumber) {
        newErrors.houseNumber = "Please enter the house number";
        isValid = false;
      } else if (houseNumber.length < 3) {
        
        newErrors.houseNumber = "House number should have at least 3 characters"
          isValid = false;
        
      } else if (!/^[A-Za-z0-9][A-Za-z0-9 _#,./-]*$/.test(houseNumber)) {
        // //console.log("")
        newErrors.houseNumber = "Please enter the valid house number";
        isValid = false;
      }


        if (!streetAddress) {
          newErrors.streetAddress = "Please enter the street address";
          isValid = false;
        } else if (streetAddress.length < 2) {
          
          newErrors.streetAddress = "Street address should have at least 2 characters"
          isValid=false
          
        } else if (!/^[A-Za-z0-9][A-Za-z0-9 _#,@./-]*$/.test(streetAddress)) {
          // //console.log("")
          newErrors.streetAddress = "Please enter the valid street address";
          isValid = false;
        }

        if (!locality) {
            newErrors.locality = 'Please select the locality';
            isValid = false;
        } 

        // Other fields can also be validated similarly if needed

        setError(newErrors);
        return isValid;
  };

  useEffect(() => {
    if (personalNameRef.current) {
      personalNameRef.current.focus();
    }
  },[])
  
  const checkValidateFields = (fieldName: any, e: any) => {
    const value = e.target.value.trimStart()
    let isValid = true;
    const newErrors: { [key: string]: string | null } = {
      name: null,
      mobileNo: null,
      email: null,
      pincode: null,
      houseNumber: null,
      streetAddress: null,
      locality: null,
      city: null,
      state: null,
    };

    let err:any = null

    // Name validation
    if (fieldName === 'name') {
      if (value.length === 0) {
        setError((pre) => ({
          ...pre,
          name: null,
        }));
      } else if (/[^a-zA-Z\s]/.test(value)) {
        setError((pre) => ({
          ...pre,
          name: "Name should not contain numbers or special characters",
        }));
      } else {
        setError((pre) => ({
          ...pre,
          name: null,
        }));
      }
    } else if (fieldName === 'mobile_no') {
      
      // Mobile number validation
      if (value.length === 0) {
        setError((pre) => ({
          ...pre,
          mobileNo: null,
        }));
      } else if (!/^\d{10}$/.test(value)) {
        setError((pre) => ({
          ...pre,
          mobileNo: "Please enter a valid 10-digit mobile number",
        }));
      } else {
        setError((pre) => ({
          ...pre,
          mobileNo: null,
        }));

      }
    } else if (fieldName === "email") {

      // Email validation
      if (value.length === 0) {
        setError((pre) => ({
          ...pre,
          email: null,
        }));
      } else if (!/^[a-zA-Z0-9@._-]+$/.test(value)) {
        setError((pre) => ({
          ...pre,
          email: "Only alphabets, numbers, and special characters (@, ., -, _) are allowed",
        }));
      } else if (!/^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(value)) {
        ;
        setError((pre) => ({ ...pre, email: "Please enter a valid email id" }));
        isValid = false;
      } else if (/^[0-9]+@/.test(value)) {
        // Check if the part before @ is only numeric
        setError((pre) => ({
          ...pre,
          email: "The part before @ cannot be only numeric",
        }));
        isValid = false;
      } else {
        setError((pre) => ({
          ...pre,
          email: null,
        }));
      }
    } else if (fieldName === "house") {

      if (value.length === 0) {
        setError((pre) => ({
          ...pre,
          houseNumber: null,
        }));
      } else if (value.length < 2) {
        setError((pre) => ({
         ...pre,
          houseNumber: "House number should have at least 2 characters",
        }));
      }
      else if (!/^[A-Za-z0-9][A-Za-z0-9 _#,./-]*$/.test(value)) {
        // //console.log("")
        setError((pre) => ({
          ...pre,
          houseNumber: "Please enter the valid house number",
        }));
        isValid = false;
      } else {
        setError((pre) => ({
          ...pre,
          houseNumber: null,
        }));
      }
    } else if (fieldName === "street") {

      if (value.length === 0) {
        setError((pre) => ({
          ...pre,
          streetAddress: null,
        }));
      } else if (value.length < 2) {
        setError((pre) => ({
          ...pre,
          streetAddress: "Street address should have at least 2 characters",
        }));
      }
      else if (!/^[A-Za-z0-9][A-Za-z0-9 _#,@./-]*$/.test(value)) {
        // //console.log("")
        setError((pre) => ({
          ...pre,
          streetAddress: "Please enter the valid street address",
        }));
      } else {
        setError((pre) => ({
          ...pre,
          streetAddress: null,
        }));
      }
    }

    

    // Other fields can also be validated similarly if needed

    // setError({ ...error,newErrors });
    // return isValid;
  };

  useEffect(() => {
    fetchSeoMetaDetails()
  },[]);

const fetchSeoMetaDetails = async () => {
    try {
        const code = 'exchange_profile_page'
        const response = await fetch(`${backendUrl}${version}seo-meta-details/${code}`,
          {  method: 'GET',
            headers:{
              // Accept:'aplication/json',
              "Content-Type": "application/json",
      
            },
            credentials: "include",
            mode:"cors"             
          }
        );
        if (!response.ok) throw new Error('Failed to fetch categories');
        const data = await response.json();
        await changeTitleAndMetaTags(data.result.page_title, {description:data.result.meta_description,keywords:data.result.meta_tag});
    } catch (error) {
        //console.error('Error fetching categories:', error);
    }
  };
  
  const changeTitleAndMetaTags = async (
    title: string,
    metaTags: { description?: string; keywords?: string; [key: string]: string | undefined }
  ) => {
    try {
        // Update the document title
        if (title) {
            document.title = title;
        } else {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
        }
  
        // Update or create meta tags
        Object.keys(metaTags).forEach((metaName) => {
            const metaTag = document.querySelector(`meta[name="${metaName}"]`);
            if (metaTag) {
                // Update existing meta tag
                metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
            } else {
                // Create new meta tag if it doesn't exist
                const newMetaTag = document.createElement('meta');
                newMetaTag.name = metaName;
                newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
                document.head.appendChild(newMetaTag);
            }
        });
  
        // Cleanup function to reset the title and meta tags when unmounting
        return () => {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
            Object.keys(metaTags).forEach((metaName) => {
                const metaTag = document.querySelector(`meta[name="${metaName}"]`);
                if (metaTag) {
                    metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
                }
            });
        };
    } catch (error) {
        //console.error("Error updating title and meta tags:", error);
    }
  };

    useEffect(() => {
        fetchCityAndState()
        fetchLocalities();
    }, []);

    const fetchCityAndState = async () => {
        try {
            const response = await fetch(`${backendUrl}api/v2/serviceable/${servicable_pincode}`,
              {  method: 'GET',
                headers:{
                  // Accept:'aplication/json',
                  "Content-Type": "application/json",
          
                },
                credentials: "include",
                mode:"cors"                           
              }
            );
            const data = await response.json();
            //console.log("stored data -------------",data)
            setCityState(data.data || []);
            setCity(data.data?.city);
            setState(data.data?.state_name);

            //console.log("fetchCityAndState -----",data.data);
           
        } catch (err: any) {
            // setError();
        }
    };

    const fetchLocalities = async () => {
        try {
            const pincode = 'your-pincode'; // Replace this with the actual pincode if required
            const response = await fetch(`${backendUrl}api/v2/locality/${servicable_pincode}`,
              {  method: 'GET',
                      headers:{
                        // Accept:'aplication/json',
                        "Content-Type": "application/json",
                
                      },
                      credentials: "include",
                      mode:"cors"                                         
                    }
            );
          const data = await response.json();
          //console.log("fetchLocalities data -------------", data);
            setLocalities(data.data || []);  // Assuming data is an array of localities
        } catch (err) {
            //console.error('Error fetching localities:', err);
        }
    };

    const handleSaveUserInfo = async () => {
      if (!validateFields()) {
        allFieldCommanError("",false,true)
        return;
      }

        setLoading(true);
        //console.log("saving payload-----------", cityState);

        try {
            const requestBody = JSON.stringify({
                  name,
                  mobile_no: mobileNo,
                  email,
                  pincode: servicable_pincode,
                  house_number: houseNumber,
                  street_address: streetAddress,
                  locality,
                  city,
                  state
            })
            //console.log("requestBody------------", requestBody);
            sessionStorage.setItem('mobile_no', mobileNo);
            const csrfToken = await fetchCsrfToken();
            const response = await fetch(
              `${backendUrl}api/v2/save-user-info/${order_id}`,
              {
                method: "PATCH",
                headers: {
                  "Content-Type": "application/json",
                  'X-CSRF-Token': csrfToken,
                },
                credentials: "include",
                body: requestBody,
                
              }
            );
            sessionStorage.setItem('addressInfo', JSON.stringify(requestBody));
            setCustInfo({CustomerCreationRequestSource:{
                MOBILE_NUMBER: mobileNo,
                EMAIL_ID:email,
                CUSTOMER_FIRST_NAME:name,
                CUSTOMER_LAST_NAME:name,
                HOUSE_NUMBER: houseNumber,
                STREET_ADDRESS: streetAddress,
                CITY:cityState?.city,
                STATE:cityState?.state_name,
                PIN_CODE:servicable_pincode,
                AREA:locality,
                ALTERNATE_NUMBER:"",
                TITLE:'',
                TYPEOFCUSTOMER:"1"
            }})

          const data = await response.json();
          //console.log("navigate before response data------------", data);

            setUserId(data.data.user_id)

            navigate('/exchange/ordersummary',{state:{prog_id,storeData,address:requestBody}})
            
            window.scrollTo({ top: 0, behavior: 'smooth' })
        } catch (err: any) {
            setError({ ...error, general: err.message });
        } finally {
            setLoading(false);
        }
    };

    const checkName = (e: any) => {
        let updatedValue = e.target.value.trimStart();
        updatedValue = updatedValue.replace(/[^a-zA-Z\s]/g, "");
      setName(updatedValue);
      if (updatedValue.length < 2 && updatedValue.length >0) {
         setError((pre) => ({
           ...pre,
           name: "Please enter at least 2 characters",
         })); 
      } else {
        setError((pre) => ({ ...pre, name: null }));
        }
        
      // allFieldCommanError("personal_name",false,false)
  }
  
  const checkHouseNumber = (e: any) => { 

  }

    return (
      <div>
        <Header />
        <main className="main-content-home container personal_detail">
          <h4 className="main-heading">Personal Details</h4>
          <div className="daikin-progessbar">
            <div className="daikin-container">
              <div className="daikin-row">
                <ul className="daikin-proDetailssProcess">
                  <li className="daikin-numOne active">
                    <div className="daikin-progNum"></div>
                    <div className="daikin-detailssSteps">Product Details</div>
                  </li>
                  <li className="daikin-numTwo active">
                    <div className="daikin-progNum"></div>
                    <div className="daikin-detailssSteps">Personal Details</div>
                  </li>
                  <li className="daikin-numThree">
                    <div className="daikin-progNum"></div>
                    <div className="daikin-detailssSteps">Summary</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="daikin-personal-info-content">
            <div className="user-info">
              <div className="select-daikin-product-brand-option">
                <div className="heading-dropdown">Name <span className='astric'> *</span></div>
                <input
                  type="text"
                  className="daikin-dropdown-user"
                  placeholder="Enter your name"
                  ref={personalNameRef}
                  value={name}
                  onChange={(e: any) => {
                    checkName(e);
                  }}
                  maxLength={50}
                />
                {error.name && (
                  <p className="error-message" style={{ color: "red" }}>
                    {error.name}
                  </p>
                )}
              </div>
              <div className="select-daikin-product-brand-option">
                <div className="heading-dropdown">Mobile No. <span className='astric'>*</span></div>
                <input
                  type="tel"
                  className="daikin-dropdown-user"
                  placeholder="Enter your mobile number"
                  value={mobileNo}
                  maxLength={14}
                  onChange={(e) => {
                    const value = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 14); // Allow only digits and limit to 10
                    setMobileNo(value);
                    if (value.length < 10) {
                      setError((prev) => ({
                        ...prev,
                        mobileNo: "10-digit required",
                      }));
                    } else {
                      setError((prev) => ({ ...prev, mobileNo: null }));
                    }
                  }}
                />
                {error.mobileNo && (
                  <p className="error-message" style={{ color: "red" }}>
                    {error.mobileNo}
                  </p>
                )}
              </div>

              <div className="select-daikin-product-brand-option">
                <div className="heading-dropdown">E-Mail ID <span className='astric'>*</span></div>
                <input
                  type="text"
                  className="daikin-dropdown-user"
                  placeholder="Enter your email address"
                  value={email}
                  maxLength={50}
                  onChange={(e) => {
                    setEmail(e.target.value.trimStart())
                    checkValidateFields("email",e);
                    
                   }}
                />
                {error.email && (
                  <p className="error-message" style={{ color: "red" }}>
                    {error.email}
                  </p>
                )}
                
              </div>
            </div>
          </div>
          <div className="daikin-personal-info-content">
            <div className="user-info">
              <div className="select-daikin-product-brand-option">
                <div className="heading-dropdown">Pincode <span className='astric'>*</span></div>
                {/* <option></option> */}
                <input
                  type="text"
                  disabled
                  className="daikin-dropdown-user"
                  placeholder={cityState?.pincode}
                  value={servicable_pincode ? servicable_pincode : pincode}
                  onChange={(e) => {
                    setPincode(e.target.value) 
                    setError((prev) => ({ ...prev, pincode: null }));
                  }}
                />
                {error.pincode && (
                  <p className="error-message" style={{ color: "red" }}>
                    {error.pincode}
                  </p>
                )}
              </div>
              <div className="select-daikin-product-brand-option">
                <div className="heading-dropdown">House Number <span className='astric'>*</span></div>
                <input
                  type="text"
                  className="daikin-dropdown-user"
                  placeholder="Enter your house number"
                  value={houseNumber}
                  maxLength={50}
                  onChange={(e) => {

                    setHouseNumber(e.target.value.trimStart())
                    checkValidateFields("house",e);
                    
                  }}
                />
                {error.houseNumber && (
                  <p className="error-message" style={{ color: "red" }}>
                    {error.houseNumber}
                  </p>
                )}
              </div>
              <div className="select-daikin-product-brand-option">
                <div className="heading-dropdown">Street Address <span className='astric'>*</span></div>
                <input
                  type="text"
                  className="daikin-dropdown-user"
                  placeholder="Enter your street address"
                  value={streetAddress}
                  maxLength={50}
                  onChange={(e) => {
                    setStreetAddress(e.target.value.trimStart()) 
                    checkValidateFields("street",e);
                  }}
                />
                {error.streetAddress && (
                  <p className="error-message" style={{ color: "red" }}>
                    {error.streetAddress}
                  </p>
                )}
              </div>
            </div>
          </div>
          <div className="daikin-personal-info-content">
            <div className="user-info">
              <div className="select-daikin-product-brand-option">
                <div className="heading-dropdown">Locality <span className='astric'>*</span></div>
                <select
                  className="daikin-dropdown-user-locality form-select"
                  value={locality}
                  onChange={(e) => {
                    setLocality(e.target.value) 
                    setError((prev) => ({ ...prev, locality: null }));
                  }}
                >
                  <option value="">Select your locality</option>
                  {localities.map((localityOption, index) => (
                    <option key={index} value={localityOption}>
                      {localityOption}
                    </option>
                  ))}
                </select>
                {error.locality && (
                  <p className="error-message" style={{ color: "red" }}>
                    {error.locality}
                  </p>
                )}
              </div>
              <div className="select-daikin-product-brand-option">
                <div className="heading-dropdown">City <span className='astric'>*</span></div>

                <input
                  type="text"
                  disabled
                  className="daikin-dropdown-user"
                  placeholder={cityState?.city}
                  value={cityState?.city}
                  onChange={(e) => setCity(e.target.value)}
                />
                {error.city && (
                  <p className="error-message" style={{ color: "red" }}>
                    {error.city}
                  </p>
                )}
              </div>
              <div className="select-daikin-product-brand-option">
                <div className="heading-dropdown">State <span className='astric'>*</span></div>

                <input
                  type="text"
                  className="daikin-dropdown-user"
                  placeholder={cityState?.state_name}
                  disabled
                  value={cityState?.state_name}
                  onChange={(e) => setState(e.target.value)}
                />
                {error.state && (
                  <p className="error-message" style={{ color: "red" }}>
                    {error.state}
                  </p>
                )}
              </div>
            </div>
          </div>
          <div className="button-save-user-info">
            <button
              className="proceed-to-form-button"
              onClick={handleSaveUserInfo}
              disabled={loading}
            >
              {loading ? "Saving..." : "Save and Next"}
            </button>
          </div>
          {error.general && (
            <p className="error-message" style={{ color: "red" }}>
              {error.general}
            </p>
          )}
        </main>
        <Footer />
      </div>
    );
};

export default PersonalInfoFormPage;
